import { z } from 'zod';

const ResourceInfoFilterParser = z.object({
  displayName: z.string(),
  term: z.string(),
  values: z.array(z.string()),
});

export const ResourceInfoParser = z.object({
  filters: z.array(ResourceInfoFilterParser),
});

const ResourceInfoFilterV2Parser = z.object({
  displayName: z.string(),
  term: z.string(),
  values: z.array(
    z.object({
      label: z.string(),
      value: z.string(),
    }),
  ),
});

export const ResourceInfoParserV2 = z.object({
  filters: z.array(ResourceInfoFilterV2Parser),
});

export type ResourceInfoFilter = z.infer<typeof ResourceInfoFilterParser>;
export type ResourceInfoFilterV2 = z.infer<typeof ResourceInfoFilterV2Parser>;
